// extracted by mini-css-extract-plugin
export var statItem = "_f2-1";
export var statsRow = "_f2-0";